import { render } from "./VerificationLinkView.vue?vue&type=template&id=f4a7f810&scoped=true"
import script from "./VerificationLinkView.vue?vue&type=script&lang=js"
export * from "./VerificationLinkView.vue?vue&type=script&lang=js"

import "./VerificationLinkView.vue?vue&type=style&index=0&id=f4a7f810&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f4a7f810"]])

export default __exports__